<template>
  <div class="pet-search-results">
    <main class="main-content">
      <section class="filters">
        <div
          class="filter-group"
          v-for="(filterGroup, groupIndex) in filterGroups"
          :key="groupIndex"
        >
          <div class="filter-title">{{ filterGroup.title }}</div>
          <div class="filter-items">
            <div
              class="filter-item"
              v-for="(option, optionIndex) in filterGroup.options"
              :key="option.value"
            >
              <input
                type="checkbox"
                :id="option.value"
                :value="option.value"
                v-model="selectedOptions[groupIndex][optionIndex]"
              />
              <label :for="option.value">{{ option.name }}</label>
            </div>
          </div>
        </div>
      </section>

      <section class="pet-list">
        <div
          class="pet-item"
          v-for="pet in paginatedPets"
          :key="pet.id"
          @click="goToProductDetail(pet)"
        >
          <img :src="pet.image" alt="Pet Image" />
          <div class="pet-info">
            <div class="pet-details">
              <span class="pet-name">{{ pet.name }}</span>
              <span class="pet-price">¥{{ pet.price }}</span>
            </div>
            <div class="owner-info">
              <el-avatar :src="pet.owner.avatar" class="owner-avatar" />
              <span>{{ pet.owner.name }}</span>
            </div>
          </div>
        </div>
      </section>

      <paginate
        :page-count="totalPages"
        :click-handler="changePage"
        :container-class="pagination"
        :page-class="page - number"
      />
    </main>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { ElAvatar } from "element-plus";
import Paginate from "vue-awesome-paginate";
import { useRoute, useRouter } from "vue-router";

export default {
  components: {
    Paginate,
    ElAvatar,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const pets = ref([
      {
        id: 1,
        name: "英国短毛猫",
        birthday: "2023-08-01",
        price: 1000,
        sex: "母",
        region: "辽宁省 沈阳市 沈北新区",
        image:
          "https://media.luoluozai.com/llz1/videos/video-covers/20250223143254pPlek2_frame_0.jpg",
        video:
          "https://media.luoluozai.com/llz1/video/1726295004331-M2-%E7%BE%8E%E5%9B%BD%E7%9F%AD%E6%AF%9B%E7%8C%AB.mp4",
        owner: {
          // id: 1,
          avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
          name: "金渐层稀有色繁育",
        },
      },
      {
        id: 2,
        name: "紫金长毛种公",
        birthday: "2025-01-06",
        price: 7500,
        sex: "公",
        region: "河南省 洛阳市 涧西区",
        image:
          "https://media.luoluozai.com/llz1/videos/video-covers/20250306161440fvj4PW_frame_0.jpg",
        video:
          "https://media.luoluozai.com/llz1/videos/20250306161440fvj4PW.mp4",
        owner: {
          // id: 1,
          avatar:
            "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
          name: "阿强酷猫坊",
        },
      },
      {
        id: 3,
        name: "缅因猫",
        birthday: "2023-09-10",
        price: 5500,
        sex: "母",
        region: "河南省 洛阳市 涧西区",
        image: "https://media.luoluozai.com/llz1/img/20250227140130EiePw5.jpg",
        video:
          "https://media.luoluozai.com/llz1/videos/20250227140123Ksnnme.mp4",
        owner: {
          // id: 1,
          avatar: "https://media.luoluozai.com/llz1/img/GhRE2ihPEb.jpg",
          name: "君喵府",
        },
      },
      {
        id: 4,
        name: "矮脚妹妹",
        birthday: "2024-10-23",
        price: 1000,
        sex: "母",
        region: "安徽省 宣城市 广德市",
        image:
          "https://media.luoluozai.com/llz1/videos/video-covers/20250306163108emqXBi_frame_0.jpg",
        video:
          "https://media.luoluozai.com/llz1/videos/20250306163108emqXBi.mp4",
        owner: {
          // id: 1,
          avatar:
            "https://media.luoluozai.com/llz1/img/20250305134436ehN65s.jpg",
          name: "喵喵咪呀家养猫咪售卖",
        },
      },
      {
        id: 5,
        name: "紫金妹妹",
        birthday: "2023-08-01",
        price: 1000,
        sex: "母",
        region: "河南省 洛阳市 涧西区",
        image:
          "https://media.luoluozai.com/llz1/videos/video-covers/20250306161828WUN1SK_frame_0.jpg",
        video:
          "https://media.luoluozai.com/llz1/video/1726295004331-M2-%E7%BE%8E%E5%9B%BD%E7%9F%AD%E6%AF%9B%E7%8C%AB.mp4",
        owner: {
          // id: 1,
          avatar:
            "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
          name: "阿强酷猫坊",
        },
      },
      {
        id: 6,
        name: "长毛弟弟",
        birthday: "2024-09-19",
        price: 1000,
        sex: "公",
        region: "安徽省 宣城市 广德市",
        image:
          "https://media.luoluozai.com/llz1/videos/video-covers/2025030616270985Z4nE_frame_0.jpg",
        video:
          "https://media.luoluozai.com/llz1/videos/2025030616270985Z4nE.mp4",
        owner: {
          // id: 1,
          avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
          name: "喵喵咪呀家养猫咪售卖",
        },
      },
      {
        id: 7,
        name: "金渐层宝宝",
        birthday: "2023-08-01",
        price: 5600,
        sex: "母",
        region: "河南省 洛阳市 涧西区",
        image:
          "https://media.luoluozai.com/llz1/videos/video-covers/20250305194908j4USPK_frame_0.jpg",
        video:
          "https://media.luoluozai.com/llz1/videos/20250305194908j4USPK.mp4",
        owner: {
          // id: 1,
          avatar:
            "https://media.luoluozai.com/llz1/img/202503051321068jdwML.jpg",
          name: "阿强酷猫坊",
        },
      },
      {
        id: 8,
        name: "长毛金虎斑妹妹",
        birthday: "2025-01-26",
        price: 1000,
        sex: "母",
        region: "安徽省 宣城市 广德市",
        image:
          "https://media.luoluozai.com/llz1/videos/video-covers/202503051455165fT5Ub_frame_0.jpg",
        video:
          "https://media.luoluozai.com/llz1/videos/202503051455165fT5Ub.mp4",
        owner: {
          // id: 1,
          avatar:
            "https://media.luoluozai.com/llz1/img/20250305134436ehN65s.jpg",
          name: "喵喵咪呀家养猫咪售卖",
        },
      },
      {
        id: 9,
        name: "两只紫金弟弟",
        birthday: "2025-01-01",
        price: 7500,
        sex: "公",
        region: "辽宁省 沈阳市 沈北新区",
        image:
          "https://media.luoluozai.com/llz1/videos/video-covers/20250223143254pPlek2_frame_0.jpg",
        video:
          "https://media.luoluozai.com/llz1/videos/20250223143254pPlek2.mp4",
        owner: {
          // id: 1,
          avatar: "https://media.luoluozai.com/llz1/img/CQhtGZG86i.jpg",
          name: "金渐层稀有色繁育",
        },
      },
    ]);

    const currentPage = ref(1);
    const petsPerPage = 10;

    const selectedRegion = ref([]);
    const selectedBreed = ref([]);
    const selectedPriceRange = ref([]);
    const selectedGender = ref([]);

    const regions = ref([
      { name: "不限", value: "0" },
      { name: "北京市", value: "1" },
      { name: "天津市", value: "2" },
      { name: "河北省", value: "3" },
      { name: "山西省", value: "4" },
      { name: "内蒙古自治区", value: "5" },
      { name: "辽宁省", value: "6" },
      { name: "吉林省", value: "7" },
      { name: "黑龙江省", value: "8" },
      { name: "上海市", value: "9" },
      { name: "江苏省", value: "10" },
      { name: "浙江省", value: "11" },
      { name: "安徽省", value: "12" },
      { name: "福建省", value: "13" },
      { name: "江西省", value: "14" },
      { name: "山东省", value: "15" },
      { name: "河南省", value: "16" },
      { name: "湖北省", value: "17" },
      { name: "湖南省", value: "18" },
      { name: "广东省", value: "19" },
      { name: "广西壮族自治区", value: "20" },
      { name: "海南省", value: "21" },
      { name: "重庆市", value: "22" },
      { name: "四川省", value: "23" },
      { name: "贵州省", value: "24" },
      { name: "云南省", value: "25" },
      { name: "西藏自治区", value: "26" },
      { name: "陕西省", value: "27" },
      { name: "甘肃省", value: "28" },
      { name: "青海省", value: "29" },
      { name: "宁夏回族自治区", value: "30" },
      { name: "新疆维吾尔自治区", value: "31" },
      { name: "香港特别行政区", value: "32" },
      { name: "澳门特别行政区", value: "33" },
      { name: "台湾省", value: "34" },
      // Add region options
    ]);
    const catBreeds = ref([
      { name: "不限", value: "1" },
      { name: "加拿大无毛猫", value: "38" },
      { name: "英短金渐层", value: "40" },
      { name: "英短银渐层", value: "41" },
      { name: "英短蓝猫", value: "42" },
      { name: "英短蓝白猫", value: "43" },
      { name: "英国短毛猫", value: "50" },
      { name: "美国短毛猫", value: "51" },
      { name: "加菲猫", value: "53" },
      { name: "德文卷毛猫", value: "56" },
      { name: "彼得秃猫", value: "188" },
      { name: "暹罗猫", value: "189" },
      { name: "阿比西尼亚猫", value: "190" },
      { name: "孟加拉豹猫", value: "191" },
      { name: "俄罗斯蓝猫", value: "192" },
      { name: "东方短毛猫", value: "193" },
      { name: "柯尼斯卷毛猫", value: "194" },
      { name: "重点色短毛猫", value: "195" },
      { name: "狼猫", value: "196" },
      { name: "孟买猫", value: "197" },
      { name: "埃及猫", value: "198" },
      { name: "缅甸猫", value: "199" },
      { name: "新加坡猫", value: "200" },
      { name: "奥西猫", value: "201" },
      { name: "东奇尼猫", value: "202" },
      { name: "呵叻猫", value: "203" },
      { name: "马恩岛猫", value: "204" },
      { name: "雪鞋猫", value: "205" },
      { name: "哈瓦那棕猫", value: "206" },
      { name: "苏格兰折耳猫", value: "207" },
      { name: "英长金渐层", value: "208" },
      { name: "英国长毛猫", value: "209" },
      { name: "布偶猫", value: "210" },
      { name: "波斯猫", value: "211" },
      { name: "缅因猫", value: "212" },
      { name: "挪威森林猫", value: "213" },
      { name: "西伯利亚森林猫", value: "214" },
      { name: "临清狮子猫", value: "215" },
      { name: "金吉拉", value: "216" },
      { name: "高地折耳猫", value: "217" },
      { name: "喜马拉雅猫", value: "218" },
      { name: "伯曼猫", value: "219" },
      { name: "巴厘猫", value: "220" },
      { name: "褴褛猫", value: "221" },
      { name: "索马里猫", value: "222" },
      { name: "土耳其梵猫", value: "223" },
      { name: "土耳其安哥拉猫", value: "224" },
      // Add breed options
    ]);

    const dogBreeds = ref([
      { name: "不限", value: "2" },
      { name: "茶杯贵宾犬", value: "81" },
      { name: "约克夏梗", value: "82" },
      { name: "马尔济斯犬", value: "90" },
      { name: "玩具贵宾犬", value: "94" },
      { name: "比熊犬", value: "95" },
      { name: "蝴蝶犬", value: "96" },
      { name: "巴哥犬", value: "97" },
      { name: "威尔士柯基犬", value: "98" },
      { name: "瑞典柯基犬", value: "99" },
      { name: "小型雪纳瑞", value: "100" },
      { name: "京巴", value: "101" },
      { name: "西施犬", value: "102" },
      { name: "迷你杜宾", value: "103" },
      { name: "腊肠犬", value: "104" },
      { name: "小鹿犬", value: "105" },
      { name: "西高地白梗", value: "106" },
      { name: "银狐犬", value: "107" },
      { name: "英国可卡犬", value: "109" },
      { name: "美国可卡犬", value: "110" },
      { name: "意大利小灵缇", value: "111" },
      { name: "小型斗牛梗", value: "112" },
      { name: "杰克罗素梗", value: "113" },
      { name: "苏格兰梗", value: "114" },
      { name: "哈瓦那犬", value: "115" },
      { name: "拉萨犬", value: "116" },
      { name: "巴吉度犬", value: "118" },
      { name: "边境牧羊犬", value: "119" },
      { name: "哈士奇", value: "121" },
      { name: "柴犬", value: "122" },
      { name: "萨摩耶犬", value: "123" },
      { name: "标准型雪纳瑞", value: "124" },
      { name: "松狮犬", value: "125" },
      { name: "法国斗牛犬", value: "126" },
      { name: "英国斗牛犬", value: "127" },
      { name: "中华田园犬", value: "128" },
      { name: "中国沙皮犬", value: "129" },
      { name: "喜乐蒂", value: "131" },
      { name: "史宾格犬", value: "132" },
      { name: "比格犬", value: "133" },
      { name: "古代牧羊犬", value: "134" },
      { name: "澳大利亚牧羊犬", value: "135" },
      { name: "德国宾莎犬", value: "136" },
      { name: "恶霸犬", value: "137" },
      { name: "波士顿梗", value: "138" },
      { name: "美国斯塔福郡梗", value: "139" },
      { name: "西藏梗", value: "140" },
      { name: "贝灵顿梗", value: "141" },
      { name: "爱尔兰梗", value: "142" },
      { name: "凯利蓝梗", value: "143" },
      { name: "万能梗", value: "144" },
      { name: "爱尔兰软毛梗", value: "145" },
      { name: "捕鼠梗", value: "146" },
      { name: "狗大麦町犬", value: "147" },
      { name: "爱斯基摩犬", value: "148" },
      { name: "博美犬", value: "225" },
      { name: "吉娃娃犬", value: "226" },
      { name: "西藏猎犬", value: "227" },
      { name: "丝毛梗", value: "228" },
      { name: "凯恩梗", value: "229" },
      { name: "湖畔梗", value: "230" },
      { name: "刚毛猎狐梗", value: "231" },
      { name: "威尔士梗", value: "232" },
      { name: "短毛猎狐梗", value: "233" },
      { name: "短脚长身梗", value: "234" },
      { name: "西帕基犬", value: "235" },
      { name: "挪威梗", value: "236" },
      { name: "罗秦犬", value: "237" },
      { name: "捷克梗", value: "238" },
      { name: "锡利哈姆梗", value: "239" },
      { name: "诺福克梗", value: "240" },
      { name: "骑士查理王猎犬", value: "241" },
      { name: "葡萄牙波登可犬", value: "242" },
      { name: "日本忡", value: "243" },
      { name: "曼彻斯特犬", value: "244" },
      { name: "爱尔兰峡谷梗", value: "245" },
      { name: "澳大利亚梗", value: "246" },
      { name: "英国玩具犬", value: "247" },
      { name: "挪威伦德猎犬", value: "248" },
      { name: "猴头梗", value: "249" },
      { name: "斯凯梗", value: "250" },
      { name: "布鲁塞尔格里芬犬", value: "251" },
      { name: "贝吉格里芬凡丁犬", value: "252" },
      { name: "博得猎狐犬", value: "253" },
      { name: "苏塞克斯猎犬", value: "254" },
      { name: "葡萄牙水犬", value: "255" },
      { name: "冰岛牧羊犬", value: "256" },
      { name: "比利牛斯牧羊犬", value: "257" },
      { name: "波兰低地牧羊犬", value: "258" },
      { name: "澳大利亚牧牛犬", value: "259" },
      { name: "波利犬", value: "260" },
      { name: "芬兰拉普猎犬", value: "261" },
      { name: "墨西哥无毛犬", value: "262" },
      { name: "荷兰毛狮犬", value: "263" },
      { name: "挪威猎鹿犬", value: "264" },
      { name: "巴仙吉犬", value: "265" },
      { name: "芬兰狐狸犬", value: "266" },
      { name: "挪威布哈德犬", value: "267" },
      { name: "惠比特犬", value: "268" },
      { name: "布列塔尼犬", value: "269" },
      { name: "美国水猎犬", value: "270" },
      { name: "西班牙小猎犬", value: "271" },
      { name: "魏玛猎犬", value: "272" },
      { name: "新斯科舍猎鸭寻猎犬", value: "273" },
      { name: "威尔士跳猎犬", value: "274" },
      { name: "田野小猎犬", value: "275" },
      { name: "帕金猎犬", value: "276" },
      { name: "金毛寻回犬", value: "278" },
      { name: "拉布拉多寻回犬", value: "279" },
      { name: "巨型贵宾犬", value: "280" },
      { name: "阿拉斯加雪橇犬", value: "281" },
      { name: "德国牧羊犬", value: "282" },
      { name: "苏格兰牧羊犬", value: "283" },
      { name: "藏獒", value: "284" },
      { name: "罗威纳犬", value: "285" },
      { name: "伯恩山犬", value: "286" },
      { name: "卡斯罗", value: "287" },
      { name: "莱州红犬", value: "288" },
      { name: "昆明犬", value: "289" },
      { name: "捷克狼犬", value: "290" },
      { name: "法国狼犬", value: "291" },
      { name: "黑狼犬", value: "292" },
      { name: "拳师犬", value: "293" },
      { name: "卷毛寻回犬", value: "294" },
      { name: "平毛寻回犬", value: "295" },
      { name: "切萨皮克海湾寻回犬", value: "296" },
      { name: "马犬", value: "297" },
      { name: "比利时牧羊犬", value: "298" },
      { name: "白色瑞士牧羊犬", value: "299" },
      { name: "匈牙利牧羊犬", value: "300" },
      { name: "波尔多犬", value: "301" },
      { name: "寻血猎犬", value: "302" },
      { name: "法老王猎犬", value: "303" },
      { name: "波音达猎犬", value: "304" },
      { name: "布雷猎犬", value: "305" },
      { name: "布鲁克浣熊猎犬", value: "306" },
      { name: "伊比赞猎犬", value: "307" },
      { name: "英国猎狐犬", value: "308" },
      { name: "树丛浣熊猎犬", value: "309" },
      { name: "红骨猎犬", value: "310" },
      { name: "黑褐猎犬", value: "311" },
      { name: "英国猎狐犬", value: "312" },
      { name: "爱尔兰雪达犬", value: "313" },
      { name: "英格兰雪达犬", value: "314" },
      { name: "戈登雪达犬", value: "315" },
      { name: "阿富汗犬", value: "316" },
      { name: "圣伯纳犬", value: "317" },
      { name: "杜高犬", value: "318" },
      { name: "斗牛獒犬", value: "319" },
      { name: "罗得西亚脊犬", value: "320" },
      { name: "猎水濑犬", value: "323" },
      { name: "卡南犬", value: "324" },
      { name: "波兰德斯布比野犬", value: "325" },
      { name: "史毕诺犬", value: "326" },
      { name: "硬毛指示格里芬犬", value: "327" },
      { name: "中国冠毛犬", value: "364" },
    ]);

    const yiChongBreeds = ref([
      { name: "不限", value: "3" },
      { name: "宠物兔", value: "153" },
      { name: "刺猬", value: "154" },
      { name: "小香猪", value: "155" },
      { name: "荷兰猪", value: "156" },
      { name: "龙猫", value: "157" },
      { name: "松鼠", value: "158" },
      { name: "仓鼠", value: "159" },
      { name: "无毛豚鼠", value: "160" },
      { name: "土拨鼠", value: "161" },
      { name: "通心粉鼠", value: "162" },
      { name: "花枝鼠", value: "163" },
      { name: "西班牙睡鼠", value: "164" },
      { name: "宠物狐狸", value: "165" },
      { name: "北美浣熊", value: "166" },
      { name: "迷你马", value: "167" },
      { name: "迷你羊", value: "168" },
      { name: "羊驼", value: "170" },
      { name: "家鸽", value: "176" },
      { name: "虎皮鹦鹉", value: "177" },
      { name: "玄凤鹦鹉", value: "178" },
      { name: "桃面牡丹鹦鹉", value: "179" },
      { name: "珍珠鸟", value: "180" },
      { name: "柯尔鸭", value: "181" },
      { name: "芦丁鸡", value: "182" },
      { name: "黄缘龟", value: "184" },
      { name: "剃刀龟", value: "185" },
      { name: "箱龟", value: "186" },
      { name: "宠物貂", value: "348" },
      { name: "猫鼬", value: "349" },
      { name: "蜜袋鼯", value: "350" },
      { name: "睫角守宫", value: "370" },
      { name: "魔物守宫", value: "371" },
      { name: "盖勾亚守宫", value: "372" },
      { name: "巨人守宫", value: "373" },
      { name: "豹纹守宫", value: "374" },
      { name: "肥尾守宫", value: "375" },
      { name: "瘤尾守宫", value: "376" },
      { name: "蓝舌龙子", value: "377" },
      { name: "鬃狮蜥", value: "378" },
      { name: "窄桥龟", value: "379" },
      { name: "墨西哥蛋龟", value: "380" },
      { name: "麝香龟", value: "381" },
      { name: "变异草龟", value: "382" },
      { name: "其它宠物龟", value: "383" },
      { name: "其它蜥蜴", value: "384" },
      { name: "其它宠物鸟", value: "385" },
    ]);

    const priceRanges = ref([
      { name: "不限", value: "" },
      { name: "1000以下", value: "1000" },
      { name: "1000至2500", value: "2500" },
      { name: "2500至5000", value: "5000" },
      { name: "5000至8000", value: "8000" },
      { name: "8000以上", value: "100000" },
      // Add price range options
    ]);
    const genders = ref([
      { name: "不限", value: "0" },
      { name: "公", value: "1" },
      { name: "母", value: "2" },
      // Add gender options
    ]);

    const filterGroups = ref([
      { title: "地区", options: regions },
      { title: "品种", options: catBreeds },
      { title: "价格", options: priceRanges },
      { title: "性别", options: genders },
    ]);

    const totalPages = computed(() =>
      Math.ceil(pets.value.length / petsPerPage)
    );
    const paginatedPets = computed(() => {
      const start = (currentPage.value - 1) * petsPerPage;
      const end = start + petsPerPage;
      return pets.value.slice(start, end);
    });

    const selectedOptions = ref([
      selectedRegion.value,
      selectedBreed.value,
      selectedPriceRange.value,
      selectedGender.value,
    ]);

    const goToProductDetail = (pet) => {
      router.push({
        name: "ProductDetail",
        params: { id: pet.id },
        query: { pet: JSON.stringify(pet) },
      });
    };

    onMounted(() => {
      const params = ["region", "breed", "priceRange", "gender"];
      params.forEach((param) => {
        if (route.query[param]) {
          selectedOptions.value.find((option) => {
            if (param === "region") option.value[0] = "selectedRegion";
            else if (param === "breed") option.value[0] = "selectedBreed";
            else if (param === "priceRange")
              option.value[0] = "selectedPriceRange";
            else if (param === "gender") option.value[0] = "selectedGender";
          }).value = route.query[param].split(",");
        }
      });
    });

    const changePage = (page) => {
      currentPage.value = page;
    };

    return {
      pets,
      currentPage,
      petsPerPage,
      totalPages,
      paginatedPets,
      changePage,
      filterGroups,
      selectedOptions,
      dogBreeds,
      yiChongBreeds,
      goToProductDetail,
    };
  },
};
</script>

<style scoped>
.pet-search-results {
  font-family: Arial, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}

.main-content {
  width: 65%;
  max-width: 1200px; /* Adjust max-width as needed */
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-group {
  width: 100%;
  margin-bottom: 20px;
}

.filter-title {
  font-weight: bold;
  margin-bottom: 30px;
}

.filter-items {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.filter-item {
  display: flex;
  align-items: center;
}

.pet-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.pet-item {
  width: calc(25% - 20px); /* 确保每行显示 4 个项目 */
  text-align: center;
}

.pet-item img {
  width: 100%; /* 使图片宽度占满父容器 */
  aspect-ratio: 1 / 1; /* 确保图片按比例展示为正方形 */
  object-fit: cover; /* 确保图像按比例缩放并裁剪以适应容器 */
  border-radius: 5px;
}

.pet-info {
  margin-top: 10px;
}

.pet-details {
  display: flex;
  justify-content: space-between; /* 分左右两边展示 */
  margin-bottom: 10px; /* 添加间隔 */
}

.pet-name {
  margin-left: 10px;
  display: block;
}

.pet-price {
  margin-right: 10px;
  display: block;
}

.owner-info {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 左对齐 */
  margin-top: 10px;
  margin-left: 10px;
}

.owner-avatar {
  width: 20px; /* 小图标大小 */
  height: 20px;
  border-radius: 50%;
  margin-right: 5px; /* 添加间隔 */
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.page-number {
  padding: 5px 10px;
  margin: 0 5px;
  background-color: #ff9900;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.page-number.active {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
